/**
 * Appends the `fm=webp` query parameter to a Contentful image URL to request the image in WebP format.
 * SVG images are excluded from this transformation.
 * If the URL is not provided or is invalid, it returns the original URL.
 *
 * @param {string | undefined} url - The original Contentful image URL.
 * @param {number | undefined} width - The desired width of the image.
 * @returns {string | undefined} - The modified URL with `fm=webp` or the original URL if invalid.
 */
export const contentfulImageUrl = (url?: string, width?: number) => {
    if (!url) {
        return url;
    }

    try {
        const urlObj = new URL(url);
        if (urlObj.pathname.endsWith('.svg')) {
            return url;
        }
        urlObj.searchParams.set('fm', 'webp');
        if (width) {
            urlObj.searchParams.set('w', String(width));
        }

        return urlObj.toString();
    } catch {
        return url;
    }
};
